export default __webpack_public_path__ + "static/media/corporate_white.3ce688bd.svg";